import WarningModal from '@3.0/Modals/WarningModal/WarningModal';
import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@redux/store';
import { closeWarningModal } from '@redux/ErrorModal/error-modal-redux-slice';

/**
 * The modal displays warning messages and error details if provided.
 * @returns A global warning modal that can be triggered from anywhere in the app using redux.
 */
const AppWarningModalWithDetails = () => {
  const warningModalState = useAppSelector((state) => state.errorModal.warningModal);
  const dispatch = useAppDispatch();
  const { isOpen, text, errorDetails } = warningModalState;

  const handleClose = useCallback(() => {
    dispatch(closeWarningModal());
  }, [dispatch]);

  if (!isOpen) {
    return null;
  }

  return (
    <WarningModal
      modalProps={{
        modalContainerProps: {
          'data-testid': 'app-warning-modal',
        },
      }}
      hideCancelButton
      showErrorDetails
      onConfirm={handleClose}
      text={text}
      errorDetails={errorDetails}
    />
  );
};

export default AppWarningModalWithDetails;
